import { render } from "./MoreElements.vue?vue&type=template&id=904a0e9e"
import script from "./MoreElements.vue?vue&type=script&lang=ts"
export * from "./MoreElements.vue?vue&type=script&lang=ts"
script.render = render

export default script